<template>
  <router-view />
</template>

<script>
  export default {
    name: "EmployeeFormulars",
  };
</script>

<style>
</style>
